import React, { PropsWithChildren } from 'react';

import { useAppSelector } from '../components/hooks';
import { getCurrentRenderMode } from '../store/slices/camera/selectors';
import { RenderMode } from '../store/slices/camera/types';
import { BearingInsertionVisual } from './component/BearingInsertionVisual';
import { SpliceInsertionVisual } from './component/SpliceInsertionVisual';
import { ComponentDesignContainer } from './ComponentDesignContainer';
import { ChordSlopes } from './dimension/ChordSlopes';
import { ComponentUserDimensions } from './dimension/ComponentUserDimensions';
import { MousyProfileInsertionDimensions } from './dimension/MousyProfileInsertionDimensions';
import { SelectedMemberDimensions } from './dimension/SelectedMemberDimensions';
import { StandardDimensions } from './dimension/StandardDimensions';
import { HangerMeshProvider } from './layout/HangerVisual';
import { LayoutModeVisuals } from './layout/LayoutModeVisuals';
import { CameraPositionAndFrustumTracker } from './layout/useCameraFrame';
import { MemberCuttingEventListeners } from './MemberCuttingEventListeners';
import { NullMenuTarget } from './NullMenuTarget';
import { ProfileVisual } from './profile/ProfileVisual';
import { ReferenceLineContainer } from './referenceLine/ReferenceLineContainer';
import { SelectionWindowVisualsAndEventListeners } from './SelectionWindowVisualsAndEventListeners';
import { GridVisual } from './util/GridVisual';

export const Scene = () => (
  <HangerMeshProvider>
    <CameraPositionAndFrustumTracker>
      <DesignRenderModeVisuals>
        <GridVisual />
        <ComponentDesignContainer />
        <ProfileVisual />
        <StandardDimensions />
        <SelectedMemberDimensions />
        <ComponentUserDimensions />
        <BearingInsertionVisual />
        <SpliceInsertionVisual />
        <ReferenceLineContainer />
        <ChordSlopes />
        <MousyProfileInsertionDimensions />
        <NullMenuTarget />
      </DesignRenderModeVisuals>

      <LayoutRenderModeVisuals>
        <LayoutModeVisuals />
      </LayoutRenderModeVisuals>

      <SelectionWindowVisualsAndEventListeners />
      <MemberCuttingEventListeners />
    </CameraPositionAndFrustumTracker>
  </HangerMeshProvider>
);

const RenderModeVisuals = (renderMode: RenderMode, { children }: PropsWithChildren) =>
  renderMode === useAppSelector(getCurrentRenderMode) && children;

const DesignRenderModeVisuals = (props: PropsWithChildren) => RenderModeVisuals('design', props);
const LayoutRenderModeVisuals = (props: PropsWithChildren) => RenderModeVisuals('layout', props);
